import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="TekRevol’s BLE">
                            <h2>TekRevol’s BLE Development Services</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>TekRevol covers the full range of beacon technology and Bluetooth low energy app development
                            services. Depending on your business niche and size, here are the core competencies we can
                            empower you with:
                        </p>
                        <p>ode review for scalability with beacon technology BLE consultancy and digital strategy BLE
                            app design for intuitive user interface and user experience Database and API integration in
                            existing apps Security and penetration testing for apps with Bluetooth and IoT Need other
                            beacon and BLE app development services for your business? </p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;